import styled from 'styled-components';
import AppHeader, { headerHeight } from '../components/AppHeader';
import { kassimBlue } from '../style/theme';

const MainContainer = styled.div`
    height: ${(props) => (props.fullscreen ? '100vh' : 'auto')};
    min-height: 100%;
    display: flex;
    flex-direction: column;
`;

export const InnerContainer = styled.div`
    padding: 16px 32px;
    height: calc(100% - ${headerHeight}px);
    box-sizing: border-box;
`;

export const CenteredContent = styled.div`
    margin: 36px auto;
`;

const MainLayout = ({ className, children, fullscreen = true }) => {
    return (
        <MainContainer fullscreen={fullscreen} className={className}>
            <AppHeader />
            {children}
        </MainContainer>
    );
};
export default MainLayout;

export const GameMainLayout = styled(MainLayout)`
    background: ${kassimBlue};
    background: linear-gradient(
        170deg,
        rgba(0, 74, 109, 1) 0%,
        rgba(52, 178, 51, 1) 75vh,
        rgba(52, 178, 51, 0.1) 120vh
    );
`;
